import Cookies from 'js-cookie';
// General functions
$(document).ready(function () {
	if (!$.visio) {
        $.visio = {};
    }
	$.visio.initHideMobiles = function () {  
		if ($(window).width() > 768) {
		  $('.hide-mobile').attr('aria-hidden', 'false');
		  $('.hide-desktop').attr('aria-hidden', 'true'); 
		} else {
		  $('.hide-mobile').attr('aria-hidden', 'true');
		  $('.hide-desktop').attr('aria-hidden', 'false');
		}    
	}
	$.visio.initMobileMenu = function () {  
		$("#mobilemenu a").prop('tabIndex', -1);  
	}
	function toggleMenu() {
		$.visio.closeSearch();
		if (!$('body').hasClass('menu-open')) {
		  $('body').addClass('menu-open');
		  $('#menu-btn i.fa').removeClass('fa-bars').addClass('fa-times');
		  $('#menu-btn').css("right","17px").css("bottom","13px");
		  $('#overlay').removeClass('hidden');
		  $('#mobilemenu').attr('aria-hidden', 'false');
		  $('#mobilemenu').prop('tabIndex', 1);
		  //$('#headercontainer').attr('aria-hidden', 'true');
		  $('#menucontainer').attr('aria-hidden', 'true');
		  $('#herocontainer').attr('aria-hidden', 'true');
		  $('#contentcontainer').attr('aria-hidden', 'true');
		  $('#footercontainer').attr('aria-hidden', 'true');
		  //tabindex uitzetten voor iedere link buiten het mobiele menu
		  $("a:not(#mobilemenu a)").prop('tabIndex', -1);
		  //menu knop en logo specifieke tabindex geven
		  $(".skipLink.tomenu").prop('tabIndex', 2);
		  $(".skipLink.tocontent").prop('tabIndex', 1);
		  $("#visio_logo").prop('tabIndex', 3);
		  $("#contrast-btn").prop('tabIndex', 4);
		  $("#search-btn").prop('tabIndex', 5);
		  $("#menu-btn").prop('tabIndex', 6);
		  //title van menu knop wijzigen
		  $(".menu-btn span").html("Menu sluiten");
		  //tabindex aanzetten voor iedere link binnen het mobiele menu
		  
		  //$("#mobilemenu a").removeAttr("tabIndex");
		  
		  var items = 7;
	  	$( "#mobilemenu a" ).each(function() {
			$(this).prop('tabIndex', items);
			items++;
		  });
		  
		  //voorkomen dat er nog gescrolld kan worden in de content door maincontent fixed te maken
		  $("#maincontent").css("position", "fixed");
		  //menu starten aan de bovenkant
		  $("#mobilemenu").scrollTop(0);
		  //eerste menuitem focus geven
		  $('#mobilemenu a:first').focus();
		  /*START change WI 30837: menu op homepage niet bruikbaar met voiceover 20-04-2016*/
		  $(".mobilehomemenus").attr('aria-hidden', 'true');
		  /*END change WI 30837: menu op homepage niet bruikbaar met voiceover 20-04-2016*/
		} else {
		  $('body').removeClass('menu-open');
		  $('#overlay').delay(600).addClass('hidden');
		  $('#menu-btn i.fa').removeClass('fa-times').addClass('fa-bars');        
		  $('#menu-btn').css("right","16px").css("bottom","12px");
		  $('#mobilemenu').attr('aria-hidden', 'true');
		  //$('#headercontainer').attr('aria-hidden', 'false');
		  $('#menucontainer').attr('aria-hidden', 'false');
		  $('#herocontainer').attr('aria-hidden', 'false');
		  $('#contentcontainer').attr('aria-hidden', 'false');
		  $('#footercontainer').attr('aria-hidden', 'false');
		  //tabindex aanzetten voor alle links op de site
		  $("a").removeAttr("tabIndex");
		  //menu knop en logo specifieke tabindex geven
		  $(".skipLink.tomenu").prop('tabIndex', 2);
		  $(".skipLink.tocontent").prop('tabIndex', 1);        
		  $("#visio_logo").prop('tabIndex', 3);
		  $("#contrast-btn").prop('tabIndex', 4);
		  $("#search-btn").prop('tabIndex', 5);
		  $("#menu-btn").prop('tabIndex', 6);
		  //title van menu knop wijzigen
		  $(".menu-btn span").html("Menu openen");
		  //tabindex uitzetten voor alle links in het mobiele menu
		  $("#mobilemenu a").prop('tabIndex', -1);
		  //site weer scrollbaar maken door position static te zetten
		  $("#maincontent").css("position", "static");
		  /*START change WI 30837: menu op homepage niet bruikbaar met voiceover 20-04-2016*/
		  $(".mobilehomemenus").attr('aria-hidden', 'false');
		  /*END change WI 30837: menu op homepage niet bruikbaar met voiceover 20-04-2016*/        
		}
	}
	$.visio.closeMenu = function () {
		if ($('body').hasClass('menu-open')) {
		  $('#menu-btn i.fa').removeClass('fa-times').addClass('fa-bars');
		  $('body').removeClass('menu-open');
		  $('#overlay').addClass('hidden');
		  $('#mobilemenu').attr('aria-hidden', 'true');
		  $('#headercontainer').attr('aria-hidden', 'false');
		  $('#menucontainer').attr('aria-hidden', 'false');
		  $('#herocontainer').attr('aria-hidden', 'false');
		  $('#contentcontainer').attr('aria-hidden', 'false');
		  $('#footercontainer').attr('aria-hidden', 'false');
		  $("#maincontent").css("position", "static");
		}
	}
	$.visio.closeSearch = function () {
		var cookieHeightPlusHeader = "0px";
		
		if ($('body').hasClass('search-open')) {
			$('body').removeClass('search-open');
			$('#search-btn i.fa').removeClass('fa-search-minus').addClass('fa-search');        
			$('#mobilesearch').attr('aria-hidden', 'true');
			$('#mobilesearch').css('height', '0px');
			$('#mobilesearch').css({"border-bottom":"0 none"}).delay(600);
			if( $('#cookies').is(':visible') ) {
				if ($(window).width() < 768) {  
					cookieHeightPlusHeader = $('#cookies').outerHeight() + 69 + "px";
					$('#maincontent').css('padding-top', cookieHeightPlusHeader);
				}
			} else {
		  		$('#maincontent').css('padding-top', '69px');
			}         
			$("#search-btn span").html("Zoekvenster openen");
		}
	} 
	$.visio.hideMobileMenu = function () {
		if ($(window).width() > 768) { 
		  $.visio.closeMenu();
		  $.visio.closeSearch();
		}
	}
	
	$.visio.initMobileMenu();
	
	$(window).resize(function() {
		$.visio.hideMobileMenu();
	});
	const menuButton = document.getElementById("open-menu");
	menuButton.addEventListener("click", () => {
		// document.body.classList.toggle("menu-open");
		// overlay.classList.toggle("hidden");
		// let hasOverlay = overlay.classList.contains("hidden");
		// if (!hasOverlay) {
		// 	document.body.classList.add("fixed");
		// } else {
		// 	document.body.classList.remove("fixed");
		// }
		toggleMenu();
	});
	$( document ).on( 'keydown', function ( e ) {
		if (e.keyCode === 27 && $('body').hasClass('menu-open')) { // ESC
			toggleMenu();
		}
		if (e.keyCode === 9) { // TAB
			$(document.activeElement).prop('test', "test");  
		}
		
	});
});

(function (window, document) {
  const savedTheme = localStorage.getItem("theme");

  if (savedTheme) {
    document.body.classList.add(savedTheme);
  }

  const themeToggle = document.getElementsByClassName("contrastswitch")?.[0];
  themeToggle.addEventListener("click", () => {
    const body = document.body;
    body.classList.toggle("contrast");
    const newTheme = document.body.classList.contains("contrast")
      ? "contrast"
      : "";
    localStorage.setItem("theme", newTheme);
  });

  const fontSizes = ["small", "medium", "large"];
  const fontSpanElements = document.querySelectorAll(".btn--textsize");
  const savedFontSize = localStorage.getItem("fontSize");

  if (fontSizes.includes(savedFontSize)) {
    document.body.classList.add(`${savedFontSize}`);
  } else {
    document.body.classList.add("small");
  }

  fontSpanElements.forEach((span) => {
    span.addEventListener("click", () => {
      const selectedSize = span.dataset.size;

      fontSizes.forEach((size) => {
        if (size === selectedSize) {
          document.body.classList.add(`${size}`);
          localStorage.setItem("fontSize", size);
        } else {
          document.body.classList.remove(`${size}`);
        }
      });
    });
  });

  const menuButton = document.getElementById("open-menu");
  const overlay = document.getElementById("overlay");
  const mobileSearchButton = document.getElementById("search-btn");
  const mobileSearchContainer = document.getElementById("mobilesearch");
  const headerHeight = document.getElementById("topbarcontainer").offsetHeight;

//   menuButton.addEventListener("click", () => {
//     document.body.classList.toggle("menu-open");
//     overlay.classList.toggle("hidden");
//     let hasOverlay = overlay.classList.contains("hidden");
//     if (!hasOverlay) {
//       document.body.classList.add("fixed");
//     } else {
//       document.body.classList.remove("fixed");
//     }
//   });

  overlay.addEventListener("click", () => {
    document.body.classList.toggle("menu-open");
    overlay.classList.toggle("hidden");
  });

  mobileSearchButton.addEventListener("click", () => {
    mobileSearchContainer.classList.toggle("active");
    mobileSearchContainer.style.top = headerHeight + "px";
	if  ( $('.mobilesearch').hasClass('active') ) {
		$("#search-btn span").html("Zoekvenster sluiten");
	} else {
		$("#search-btn span").html("Zoekvenster openen");
	}
  });

  window.addEventListener("resize", () => {
    let cookies = Cookies.get('AVGVisioPermissions') ? true : false;
    let cookieBar = document.querySelector('#cookies');
    let topBarContainer = document.getElementById("topbarcontainer");
    if (!cookies && !cookieBar) {
      (cookieBar?.offsetHeight + "px") !== topBarContainer.style.marginTop && (topBarContainer.style.marginTop = cookieBar?.offsetHeight + "px");
    } else {
      topBarContainer.style.marginTop = 0;
    }

    if (window.innerWidth > 768) {
      document.body.classList.remove("menu-open");
      document.body.classList.remove("fixed");
      let hasOverlay = overlay.classList.contains("hidden");
      if (!hasOverlay) {
        overlay.classList.add("hidden");
      }
    }
  });

  $.fn.setup_navigation = function(options) {
	var settings = $.extend({
		menuHoverClass: "show-menu"
	}, options);

	// Target the specific ul with id "domeinmenu"
	var menuItems = $("#domeinmenu").find("> li > a");

	menuItems.next("ul").attr({
		"aria-hidden": "false",
		role: "menu"
	}).find("a").attr("tabIndex", -1);

	menuItems.each(function() {
		if ($(this).next("ul").length > 0) {
			$(this).parent("li").attr("aria-haspopup", "true");
		}
	});

	menuItems.hover(function() {
		handleMenuItemInteraction($(this), settings);
	});

	menuItems.focus(function() {
		handleMenuItemInteraction($(this), settings);
	});

	menuItems.keydown(function(e) {
		handleKeyDownEvent($(this), e, settings);
	});

	var submenuItems = menuItems.parent("li").find("ul").find("a");

	submenuItems.keydown(function(e) {
		handleSubmenuKeyDownEvent($(this), e, settings);
	});

	menuItems.find("a").last().keydown(function(e) {
		if (e.keyCode === 9) {
			$("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
		}
	});

	menuItems.mouseleave(function() {
		$("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
	});

	$(document).click(function() {
		$("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
	});

	$(this).click(function(e) {
		e.stopPropagation();
	});

	function handleMenuItemInteraction(item, settings) {
		item.closest("ul").attr("aria-hidden", "false").find("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
		item.next("ul").attr("aria-hidden", "false").addClass(settings.menuHoverClass).find("a").attr("tabIndex", 0);
	}

	function handleKeyDownEvent(item, event, settings) {
		var keyCode = event.keyCode;

		// switch (keyCode) {
		// 	case 37:
		// 		handleArrowKey(item, "left");
		// 		break;
		// 	case 38:
		// 		handleArrowKey(item, "up", settings);
		// 		break;
		// 	case 39:
		// 		handleArrowKey(item, "right");
		// 		break;
		// 	case 40:
		// 		handleArrowKey(item, "down", settings);
		// 		break;
		// 	case 13:
		// 	case 32:
		// 		handleEnterSpaceKey(item);
		// 		break;
		// 	case 27:
		// 		handleEscapeKey(settings);
		// 		break;
		// 	default:
		// 		handleAlphabetKey(item, keyCode);
		// }
	}

	function handleSubmenuKeyDownEvent(item, event, settings) {
		var keyCode = event.keyCode;

		// Handle submenu keydown events
		// Add your logic here
	}

	function handleEscapeKey(settings) {
		$("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
	}

};

$.fn.setup_navigation();



$(function(){
	
	var keyCodeMap = {
			48:"0", 49:"1", 50:"2", 51:"3", 52:"4", 53:"5", 54:"6", 55:"7", 56:"8", 57:"9", 59:";",
			65:"a", 66:"b", 67:"c", 68:"d", 69:"e", 70:"f", 71:"g", 72:"h", 73:"i", 74:"j", 75:"k", 76:"l",
			77:"m", 78:"n", 79:"o", 80:"p", 81:"q", 82:"r", 83:"s", 84:"t", 85:"u", 86:"v", 87:"w", 88:"x", 89:"y", 90:"z",
			96:"0", 97:"1", 98:"2", 99:"3", 100:"4", 101:"5", 102:"6", 103:"7", 104:"8", 105:"9"
	}

	$.fn.setup_keyboard_navigation = function(settings) {
		settings = jQuery.extend({
			menuHoverClass: 'show-menu',
		}, settings);
		
		// Add ARIA role to menubar and menu items
		//$(this).attr('role', 'menubar').find('li').attr('role', 'menuitem');
		
		var top_level_links = $(this).find('> li > a');
		
		// Set tabIndex to -1 so that top_level_links can't receive focus until menu is open
		$(top_level_links).next('ul')
			//.attr({ 'aria-hidden': 'true', 'role': 'menu' })
			.attr({ 'aria-hidden': 'false', 'role': 'menu' })
			.find('a')
				.attr('tabIndex',-1);
		
		// Adding aria-haspopup for appropriate items
		$(top_level_links).each(function(){
			if($(this).next('ul').length > 0)
				$(this).parent('li').attr('aria-haspopup', 'true');
		});
		
		$(top_level_links).hover(function(){
			$(this).closest('ul')
				.attr('aria-hidden', 'false')
				.find('.'+settings.menuHoverClass)
					//.attr('aria-hidden', 'true')
					.attr('aria-hidden', 'false')
					.removeClass(settings.menuHoverClass)
					.find('a')
						.attr('tabIndex',-1);
			$(this).next('ul')
				.attr('aria-hidden', 'false')
				.addClass(settings.menuHoverClass)
				.find('a').attr('tabIndex',0);
		});
		$(top_level_links).focus(function(){
			$(this).closest('ul')
				.attr('aria-hidden', 'false')
				.find('.'+settings.menuHoverClass)
					//.attr('aria-hidden', 'true')
					.attr('aria-hidden', 'false')
					.removeClass(settings.menuHoverClass)
					.find('a')
						.attr('tabIndex',-1);
			$(this).next('ul')
				.attr('aria-hidden', 'false')
				.addClass(settings.menuHoverClass)
				.find('a').attr('tabIndex',0);
		});
		
		// Bind arrow keys for navigation
		$(top_level_links).keydown(function(e){
			if(e.keyCode == 37) {
				e.preventDefault();
				// This is the first item
				if($(this).parent('li').prev('li').length == 0) {
					$(this).parents('ul').find('> li').last().find('a').first().focus();
				} else {
					$(this).parent('li').prev('li').find('a').first().focus();
				}
			} else if(e.keyCode == 38) {
				e.preventDefault();
				if($(this).parent('li').find('ul').length > 0) {
					$(this).parent('li').find('ul')
						.attr('aria-hidden', 'false')
						.addClass(settings.menuHoverClass)
						.find('a').attr('tabIndex',0)
							.last().focus();
				}
			} else if(e.keyCode == 39) {
				e.preventDefault();
				// This is the last item
				if($(this).parent('li').next('li').length == 0) {
					$(this).parents('ul').find('> li').first().find('a').first().focus();
				} else {
					$(this).parent('li').next('li').find('a').first().focus();
				}
			} else if(e.keyCode == 40) {
				e.preventDefault();
				if($(this).parent('li').find('ul').length > 0) {
					$(this).parent('li').find('ul')
						.attr('aria-hidden', 'false')
						.addClass(settings.menuHoverClass)
						.find('a').attr('tabIndex',0)
							.first().focus();
				}
			} else if(e.keyCode == 13 || e.keyCode == 32) {
				// If submenu is hidden, open it
				e.preventDefault();
				$(this).parent('li').find('ul[aria-hidden=true]')
						.attr('aria-hidden', 'false')
						.addClass(settings.menuHoverClass)
						.find('a').attr('tabIndex',0)
							.first().focus();
			} else if(e.keyCode == 27) {
				e.preventDefault();
				$('.'+settings.menuHoverClass)
					//.attr('aria-hidden', 'true')
					.attr('aria-hidden', 'false')
					.removeClass(settings.menuHoverClass)
					.find('a')
						.attr('tabIndex',-1);
			} else {
				$(this).parent('li').find('ul[aria-hidden=false] a').each(function(){
					if($(this).text().substring(0,1).toLowerCase() == keyCodeMap[e.keyCode]) {
						$(this).focus();
						return false;
					}
				});
			}
		});
		
		
		var links = $(top_level_links).parent('li').find('ul').find('a');
		$(links).keydown(function(e){
			if(e.keyCode == 38) {
				e.preventDefault();
				// This is the first item
				if($(this).parent('li').prev('li').length == 0) {
					$(this).parents('ul').parents('li').find('a').first().focus();
				} else {
					$(this).parent('li').prev('li').find('a').first().focus();
				}
			} else if(e.keyCode == 40) {
				e.preventDefault();
				if($(this).parent('li').next('li').length == 0) {
					$(this).parents('ul').parents('li').find('a').first().focus();
				} else {
					$(this).parent('li').next('li').find('a').first().focus();
				}
			} else if(e.keyCode == 27 || e.keyCode == 37) {
				e.preventDefault();
				$(this)
					.parents('ul').first()
						.prev('a').focus()
						.parents('ul').first().find('.'+settings.menuHoverClass)
							//.attr('aria-hidden', 'true')
							.attr('aria-hidden', 'false')
							.removeClass(settings.menuHoverClass)
							.find('a')
								.attr('tabIndex',-1);
			} else if(e.keyCode == 32) {
				e.preventDefault();
				window.location = $(this).attr('href');
			} else {
				var found = false;
				$(this).parent('li').nextAll('li').find('a').each(function(){
					if($(this).text().substring(0,1).toLowerCase() == keyCodeMap[e.keyCode]) {
						$(this).focus();
						found = true;
						return false;
					}
				});
				
				if(!found) {
					$(this).parent('li').prevAll('li').find('a').each(function(){
						if($(this).text().substring(0,1).toLowerCase() == keyCodeMap[e.keyCode]) {
							$(this).focus();
							return false;
						}
					});
				}
			}
		});

			
		// Hide menu if click or focus occurs outside of navigation
		$(this).find('a').last().keydown(function(e){ 
			if(e.keyCode == 9) {
				// If the user tabs out of the navigation hide all menus
				$('.'+settings.menuHoverClass)
					//.attr('aria-hidden', 'true')
					.attr('aria-hidden', 'false')
					.removeClass(settings.menuHoverClass)
					.find('a')
						.attr('tabIndex',-1);
			}
		});
		
		// Verberg menu als hover niet meer binnen menugrenzen
		$(top_level_links).mouseleave(function(){
		//$('.'+settings.menuHoverClass).attr('aria-hidden', 'true').removeClass(settings.menuHoverClass).find('a').attr('tabIndex',-1);
		$('.'+settings.menuHoverClass).attr('aria-hidden', 'false').removeClass(settings.menuHoverClass).find('a').attr('tabIndex',-1);
		});	
		
		//$(document).click(function(){ $('.'+settings.menuHoverClass).attr('aria-hidden', 'true').removeClass(settings.menuHoverClass).find('a').attr('tabIndex',-1); });
		$(document).click(function(){ $('.'+settings.menuHoverClass).attr('aria-hidden', 'false').removeClass(settings.menuHoverClass).find('a').attr('tabIndex',-1); });
		
		$(this).click(function(e){
			e.stopPropagation();
		});
	}
	$('#domeinmenu').setup_keyboard_navigation();
});

})(window, document);
